export default __webpack_public_path__ + "static/media/bike-truck.0a60745f.jpg";